import React, { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import ModalForDocumentPreview from '../ModalForDocumentPreview';

const AttachmentRow = (props) => {
  const {
    attachment,
    handleDownload,
    controllerReference,
    signal,
    handleDelete,
  } = props || {};
  const { embeddableAttribute } = attachment || {};
  const [showModal, setShowModal] = useState(false);

  const onDownloadClick = () => {
    handleDownload(embeddableAttribute?.uuidName, embeddableAttribute?.name);
  };

  const onPreviewClick = () => {
    return setShowModal(true);
  };

  const onPreviewClose = () => {
    return setShowModal(false);
  };

  const onDeleteClick = (attachment) => {
    handleDelete(attachment);
  };

  const rowContent = (
    <tr>
      <td className="text-left">{embeddableAttribute?.name}</td>
      <td className="text-center">
        <Link id="previewFile" onClick={onPreviewClick} to="#">
          <i className="fas fa-search fa-2x" />
        </Link>
      </td>
      {!signal && (
        <td className="text-center">
          <Link id="downloadFile" onClick={onDownloadClick} to="#">
            <i className="fas fa-download"></i>
          </Link>
        </td>
      )}
      {!!signal && (
        <td className="text-center">
          <Link
            id="deleteDocument"
            onClick={() => onDeleteClick(attachment)}
            to="#"
          >
            <i className="fas fa-trash-alt fa-2x iconColor deleteIcon" />
          </Link>
        </td>
      )}
    </tr>
  );

  return (
    <Fragment>
      {rowContent}
      {showModal && (
        <ModalForDocumentPreview
          documentName={embeddableAttribute.uuidName}
          controllerReference={controllerReference}
          handleClose={onPreviewClose}
          show={showModal}
        />
      )}
    </Fragment>
  );
};

export default AttachmentRow;
